<template>
  <div
    :class="$style.video_card"
    @click="handleClick"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <!-- Верхняя часть: Thumbnail area -->
    <div :class="$style.video_card__top">
      <play-button
        :class="$style.video_card__play_button"
        :is-hovered="isHovered"
      />
      <div
        v-if="video.thumbnail"
        :class="$style.video_card__thumbnail"
      >
        <img
          :src="video.thumbnail"
          :alt="video.title"
        >
      </div>
    </div>
    <div :class="$style.video_card__bottom">
      <div :class="$style.video_card__meta">
        <span :class="$style.video_card__label">
          VIDEO
        </span>
        <span :class="$style.video_card__duration">
          {{ video.duration }}
        </span>
      </div>
      <div :class="$style.video_card__title_bottom">
        {{ video.title }}
      </div>
    </div>
  </div>
</template>

<script>
import PlayButton from './playButton.vue';

export default {
  name: 'LearningCenterVideoCard',
  components: {
    PlayButton: PlayButton,
  },
  props: {
    video: {
      type: Object,
      required: true,
      validator(value) {
        return value.id && value.title && value.youtubeId;
      },
    },
  },
  emits: ['open-video'],
  data() {
    return {
      isHovered: false,
    };
  },
  methods: {
    handleClick() {
      userExtAnalytics.log('learning_center_video_clicked', {
        videoId: this.video.id,
        videoTitle: this.video.title,
      });
      this.$emit('open-video', this.video.youtubeId);
    },
  },
};
</script>

<style module src="./learningCenterVideoCard.less" lang="less">
</style>

